import { Play, Pause, RotateCcw } from 'lucide-react';
import { SPEEDS, clockOf } from './useRouteSim';
import { LEG_COLORS } from './helpers';
import { useI18nStore } from '../../lib/i18n';
const tt = (k, p) => useI18nStore.getState().t(`startStopAdmin.${k}`, p);

const PHASE_KEYS = { depot_start: 'simToStart', start_stop: 'simTour', stop_depot: 'simBack', end: 'simAtDepot' };

export function SimControls({ s }) {
  const { sim, t, setT, playing, toggle, speed, setSpeed, pos, clock } = s;
  const label = PHASE_KEYS[pos.phase];
  const color = LEG_COLORS[pos.phase] || '#0f172a';
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-3 space-y-2" data-testid="ss-sim-controls">
      <div className="flex items-center gap-3">
        <button type="button" onClick={toggle} className="h-11 w-11 shrink-0 rounded-full bg-slate-900 text-white flex items-center justify-center hover:bg-slate-700 active:scale-95 transition-[background-color,transform]" data-testid="ss-sim-play">
          {playing ? <Pause className="h-5 w-5" /> : <Play className="h-5 w-5 fill-white" />}
        </button>
        <div className="min-w-0 flex-1">
          <div className="text-3xl font-black tabular-nums leading-none" data-testid="ss-sim-clock">{clock}</div>
          <div className="text-[11px] font-semibold mt-1 flex items-center gap-1.5" style={{ color }} data-testid="ss-sim-phase"><span className="h-2 w-2 rounded-full" style={{ background: color }} />{tt(label)}</div>
        </div>
        <div className="flex rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden" data-testid="ss-sim-speed">
          {Object.keys(SPEEDS).map((k) => (
            <button key={k} type="button" onClick={() => setSpeed(Number(k))} data-testid={`ss-sim-speed-${k}`}
              className={`px-2.5 h-8 text-xs font-bold transition-colors ${speed === Number(k) ? 'bg-slate-900 text-white' : 'text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>{k}x</button>
          ))}
        </div>
        <button type="button" onClick={() => setT(0)} className="p-2 text-slate-400 hover:text-slate-900" title={tt('simReset')} data-testid="ss-sim-reset"><RotateCcw className="h-4 w-4" /></button>
      </div>
      <div className="relative pt-1">
        <div className="absolute left-0 right-0 top-[11px] h-1.5 rounded-full overflow-hidden flex pointer-events-none">
          {sim.segs.map((g) => <span key={g.key} style={{ width: `${sim.total ? (g.dur / sim.total) * 100 : 0}%`, background: LEG_COLORS[g.key], opacity: 0.35 }} />)}
        </div>
        <input type="range" min={0} max={sim.total || 1} step={1} value={t} onChange={(e) => setT(Number(e.target.value))} className="relative w-full accent-slate-900" data-testid="ss-sim-slider" />
        <div className="flex justify-between text-[10px] text-slate-400 tabular-nums">
          {sim.segs.filter((g, i) => i === 0 || g.dur > 0).map((g) => <span key={g.key}>{clockOf(sim.depart + g.t0)}</span>)}
          <span>{clockOf(sim.depart + sim.total)}</span>
        </div>
      </div>
    </div>
  );
}
